export enum EligibilityStatus {
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  RAD_IN_DEPLOYMENT = 'RAD_IN_DEPLOYMENT',
  CONNECTION_ON_DEMAND = 'CONNECTION_ON_DEMAND',
  IN_DEPLOYMENT = 'IN_DEPLOYMENT',
  TARGETED = 'TARGETED',
  FROZEN_ADDRESS = 'FROZEN_ADDRESS',
  ELIGIBLE = 'ELIGIBLE',
  NO_STATUS = 'NO_STATUS'
}

export default EligibilityStatus;
